import { render, staticRenderFns } from "./Comp6t3.vue?vue&type=template&id=0bae3342&scoped=true&"
import script from "./Comp6t3.vue?vue&type=script&lang=js&"
export * from "./Comp6t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp6t3.vue?vue&type=style&index=0&id=0bae3342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae3342",
  null
  
)

export default component.exports